import { render } from "./cookieWarning.vue?vue&type=template&id=4b2b5de6"
import script from "./cookieWarning.vue?vue&type=script&lang=js"
export * from "./cookieWarning.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__